import React from "react";
import { CustomerApplicationFormModel } from "./types/CustomerApplicationFormModel";
import ApplicationForm from "./ui/ApplicationForm";

const CustomerApplicationForm = (model : CustomerApplicationFormModel) => {
    
    return (<>
        <ApplicationForm model={model} />
    </>);
}

export default CustomerApplicationForm;